import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import axios from "axios";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { toast } from "react-toastify";
import AdminImageUploadZone from "../../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";

function Site_Setting(props) {
  const [loading, setLoading] = useState(true);
  // const [message, setMessage] = useState("");
  const [logo, setLogo] = useState("");
  const [favicon, setFavicon] = useState("");

  const [setting, setSetting] = useState({
    // Advertisement_Setting
    ads_on_videos: "",
    cpc_advertiser: "",
    featured_pre_ad: "",
    featured_mid_ad: "",
    featured_post_ad: "",
    cpc_admin: "",
    cpv_advertiser: "",
    cpv_admin: "",
    default_ads_url: "",
    ads_play_unlimited_period: "",
    ads_on_livestream: "",
    ads_on_audios: "",
    ads_on_episodes: "",
    // Advertisement_Setting
    //coupon code
    new_subscriber_coupon: "",
    discount_percentage: "",
    coupon_code: "",
    //coupon code
    //email setting
    google_oauth_key: "",
    coupon_status: "",
    google_tracking_id: "",
    system_email: "",
    system_phone_number: "",
    system_address: "",
    //email setting
    //login setting
    notification_icon: "",
    notification_key: "",
    login_text: "",
    login_content: "",
    signature: "",
    //login setting
    //geo fencing
    id: "",
    geofencing: "",
    // geofencing_status: "",
    //geo fencing
    // payout setting
    payout_method: "",
    //payout setting
    //ppv setting
    ppv_status: "",
    ppv_rent: "",
    ppv_price: "",
    ppv_hours: "",
    ios_product_id: "",
    ios_plan_price: "",
    expiry_time_started: "",
    expiry_day_notstarted: "",
    expiry_hours_notstarted: "",
    expiry_min_notstarted: "",
    PPV_Individual_Contents: "",
    enable_ppv_rent_live: "",
    enable_ppv_rent_series: "",
    enable_ppv_rent_audio: "",
    google_analytics_link: "",
    //ppv setting
    // capcha setting
    captcha_site_key: "",
    captcha_secret_key: "",
    captcha: "",
    //capcha setting
    //registration settings
    free_registration: "",
    activation_email: "",
    premium_upgrade: "",
    access_free: "",
    enable_landing_page: "",
    //registration settings
    //search settings
    search_title_status: "",
    search_category_status: "",
    search_tags_status: "",
    search_description_status: "",
    search_details_status: "",
    //search settings
    //series settings
    series_season: "",
    series_networks_status: "",
    //series settings
    //site settings
    website_name: "",
    website_description: "",
    logo_height: "",
    logo_width: "",
    login_content: "",
    favicon: "",
    logo: "",
    //site settings
    //social network settings
    facebook_page_id: "",
    google_page_id: "",
    twitter_page_id: "",
    instagram_page_id: "",
    linkedin_page_id: "",
    whatsapp_page_id: "",
    skype_page_id: "",
    youtube_page_id: "",
    email_page_id: "",
    tiktok_page_id: "",
    //social network settings
    //video settings
    videos_per_page: "",
    posts_per_page: "",
    show_description: "",
    show_Links_and_details: "",
    show_genre: "",
    show_languages: "",
    show_subtitle: "",
    show_artist: "",
    show_recommended_videos: "",
    show_views: "",
    videos_expiry_status: "",
    epg_status: "",
    //video settings
    earn_amount: "",
    video_clip_enable: "",

    enable_ppv_rent: "",
    enable_skeleton_loader: 0,
    google_font_url: "",
    google_font_name: "",
    font_file: "",
    admin_setting_id: 1,
  });


  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/setting/index`, {
        headers: headers,
      });
      var setting = response?.data?.setting;
      var logo = response?.data?.setting?.logo;
      var favicon = response?.data?.setting?.favicon;
      setSetting(setting);
      setFavicon(favicon);
      setLogo(logo);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInput = (e) => {
    const { name, value, type } = e.target;

    if (type === "number" && Number(value) < 0) return;

    if ((name === "logo_width" || name === "logo_height") && value.length > 4) return;


    if (name === "website_name" && value.length > 30) return;

    // Clear all validation messages
    setValidationMessagewebsite_name("");
    setIsValidationHiddenwebsite_name(true);
    setValidationMessagelogo_height("");
    setIsValidationHiddenlogo_height(true);
    setValidationMessagelogo_width("");
    setIsValidationHiddenlogo_width(true);

    // Update setting state
    setSetting((prevSetting) => ({
      ...prevSetting,
      [name]: value,
    }));
  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setSetting({ ...setting, [e.target.name]: 1 });
    } else {
      setSetting({ ...setting, [e.target.name]: 0 });
    }
  };

  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [selectedFontFile, setSelectedFontFile] = useState(null);

  const handleFileChange = async (event) => {
    const { files, name } = event.target;
    if (files?.length > 0) {
      const newFile = files[0];
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/x-icon', 'image/vnd.microsoft.icon', 'image/webp'];
      if (!allowedTypes.includes(newFile?.type)) {
        // Optionally surface an error message here
        return;
      }
      if (name === 'favicon') {
        setSelectedFile1(newFile);
      } else if (name === 'logo') {
        setSelectedFile2(newFile);
      }
    }
  };

  const handleClearSelectFile = (fieldName) => {
    if (fieldName === 'favicon') {
      setSelectedFile1(null);
    } else if (fieldName === 'logo') {
      setSelectedFile2(null);
    }
  };

  const handleFontFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const isValidTTF = file.name.toLowerCase().endsWith('.ttf') || file.type === 'font/ttf' || file.type === 'application/x-font-ttf';
    if (!isValidTTF) {
      toast.error("Only .ttf font files are allowed.");
      e.target.value = "";
      return;
    }
    setSelectedFontFile(file);
  };

  const handleClearFontFile = () => {
    setSelectedFontFile(null);
  };

  const [validationMessagewebsite_name, setValidationMessagewebsite_name] =
    useState("");
  const [isValidationHiddenwebsite_name, setIsValidationHiddenwebsite_name] =
    useState(true);

  const [validationMessagelogo_width, setValidationMessagelogo_width] =
    useState("");
  const [isValidationHiddenlogo_width, setIsValidationHiddenlogo_width] =
    useState(true);

  const [validationMessagelogo_height, setValidationMessagelogo_height] =
    useState("");
  const [isValidationHiddenlogo_height, setIsValidationHiddenlogo_height] =
    useState(true);

  const website_nameInputRef = useRef(null);
  const logo_widthInputRef = useRef(null);
  const logo_heightInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();

    let focusInputRef = null;

    const trimmedWebsiteName = setting?.website_name?.trim();

    if (trimmedWebsiteName === "") {
      setValidationMessagewebsite_name("Website Name cannot be empty.");
      setIsValidationHiddenwebsite_name(false);
      focusInputRef = website_nameInputRef;
    } if (setting?.logo_width === "") {
      setValidationMessagelogo_width("Logo Width cannot be empty.");
      setIsValidationHiddenlogo_width(false);
      focusInputRef = website_nameInputRef;
    } if (setting?.logo_height === "") {
      setValidationMessagelogo_height("Logo Height cannot be empty.");
      setIsValidationHiddenlogo_height(false);
      focusInputRef = logo_heightInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }


    const enable_ppv_rent = Number.isNaN(parseInt(setting?.enable_ppv_rent, 10)) ? 0 : parseInt(setting?.enable_ppv_rent, 10);

    // advertisement setting
    const ads_on_videos = Number.isNaN(parseInt(setting?.ads_on_videos, 10)) ? 0 : parseInt(setting?.ads_on_videos, 10);
    const ads_play_unlimited_period = Number.isNaN(parseInt(setting?.ads_play_unlimited_period, 10)) ? 0 : parseInt(setting?.ads_play_unlimited_period, 10);
    const ads_on_livestream = Number.isNaN(parseInt(setting?.ads_on_livestream, 10)) ? 0 : parseInt(setting?.ads_on_livestream, 10);
    const ads_on_audios = Number.isNaN(parseInt(setting?.ads_on_audios, 10)) ? 0 : parseInt(setting?.ads_on_audios, 10);
    const ads_on_episodes = Number.isNaN(parseInt(setting?.ads_on_episodes, 10)) ? 0 : parseInt(setting?.ads_on_episodes, 10);

    //coupon setting      
    const coupon_code = Number.isNaN(parseInt(setting?.coupon_code, 10)) ? 0 : parseInt(setting?.coupon_code, 10);


    //payout settings   
    const payout_method = Number.isNaN(parseInt(setting?.payout_method, 10)) ? 0 : parseInt(setting?.payout_method, 10);


    //registration settings
    const free_registration = Number.isNaN(parseInt(setting?.free_registration, 10)) ? 0 : parseInt(setting?.free_registration, 10);


    //search settings
    const search_title_status = Number.isNaN(parseInt(setting?.search_title_status, 10)) ? 0 : parseInt(setting?.search_title_status, 10);
    const search_category_status = Number.isNaN(parseInt(setting?.search_category_status, 10)) ? 0 : parseInt(setting?.search_category_status, 10);
    const search_tags_status = Number.isNaN(parseInt(setting?.search_tags_status, 10)) ? 0 : parseInt(setting?.search_tags_status, 10);
    const search_description_status = Number.isNaN(parseInt(setting?.search_description_status, 10)) ? 0 : parseInt(setting?.search_description_status, 10);
    const search_details_status = Number.isNaN(parseInt(setting?.search_details_status, 10)) ? 0 : parseInt(setting?.search_details_status, 10);


    //serires settings
    const series_networks_status = Number.isNaN(parseInt(setting?.series_networks_status, 10)) ? 0 : parseInt(setting?.series_networks_status, 10);

    // video settings 
    const videos_expiry_status = Number.isNaN(parseInt(setting?.videos_expiry_status, 10)) ? 0 : parseInt(setting?.videos_expiry_status, 10);
    const videos_per_page = Number.isNaN(parseInt(setting?.videos_per_page, 10)) ? 0 : parseInt(setting?.videos_per_page, 10);
    const epg_status = Number.isNaN(parseInt(setting?.epg_status, 10)) ? 0 : parseInt(setting?.epg_status, 10);
    const show_genre = Number.isNaN(parseInt(setting?.show_genre, 10)) ? 0 : parseInt(setting?.show_genre, 10);
    const show_languages = Number.isNaN(parseInt(setting?.show_languages, 10)) ? 0 : parseInt(setting?.show_languages, 10);
    const show_subtitle = Number.isNaN(parseInt(setting?.show_subtitle, 10)) ? 0 : parseInt(setting?.show_subtitle, 10);
    const show_artist = Number.isNaN(parseInt(setting?.show_artist, 10)) ? 0 : parseInt(setting?.show_artist, 10);
    const show_recommended_videos = Number.isNaN(parseInt(setting?.show_recommended_videos, 10)) ? 0 : parseInt(setting?.show_recommended_videos, 10);
    const show_views = Number.isNaN(parseInt(setting?.show_views, 10)) ? 0 : parseInt(setting?.show_views, 10);
    const show_Links_and_details = Number.isNaN(parseInt(setting?.show_Links_and_details, 10)) ? 0 : parseInt(setting?.show_Links_and_details, 10);
    const show_description = Number.isNaN(parseInt(setting?.show_description, 10)) ? 0 : parseInt(setting?.show_description, 10);

    const editInputvalue = {

      // advertisement setting
      ads_on_videos: ads_on_videos,
      default_ads_url: setting?.default_ads_url,
      featured_pre_ad: setting?.featured_pre_ad,
      featured_mid_ad: setting?.featured_mid_ad,
      featured_post_ad: setting?.featured_post_ad,
      cpv_admin: setting?.cpv_admin,
      cpv_advertiser: setting?.cpv_advertiser,
      cpc_admin: setting?.cpc_admin,
      cpc_advertiser: setting?.cpc_advertiser,
      ads_play_unlimited_period: ads_play_unlimited_period,
      ads_on_livestream: ads_on_livestream,
      ads_on_audios: ads_on_audios,
      ads_on_episodes: ads_on_episodes,

      //coupon setting      
      discount_percentage: setting?.discount_percentage,
      coupon_code: coupon_code,
      new_subscriber_coupon: setting?.new_subscriber_coupon,

      //email settings
      coupon_status: setting?.coupon_status,
      google_tracking_id: setting?.google_tracking_id,
      google_oauth_key: setting?.google_oauth_key,
      system_email: setting?.system_email,
      system_phone_number: setting?.system_phone_number,

      //login settings      
      login_text: setting?.login_text,
      signature: setting?.signature,
      login_content: setting?.login_content,
      notification_key: setting?.notification_key,

      //payout setting
      payout_method: payout_method,

      //ppv settings
      ppv_status: setting?.ppv_status,
      PPV_Individual_Contents: setting?.PPV_Individual_Contents,
      ppv_price: setting?.ppv_price,
      ppv_hours: setting?.ppv_hours,
      ios_plan_price: setting?.ios_plan_price,
      ios_product_id: setting?.ios_product_id,
      expiry_time_started: setting?.expiry_time_started,
      expiry_day_notstarted: setting?.expiry_day_notstarted,
      expiry_hours_notstarted: setting?.expiry_hours_notstarted,
      expiry_min_notstarted: setting?.expiry_min_notstarted,
      enable_ppv_rent_live: setting?.enable_ppv_rent_live,
      enable_ppv_rent_series: setting?.enable_ppv_rent_series,
      enable_ppv_rent_audio: setting?.enable_ppv_rent_audio,
      google_analytics_link: setting?.google_analytics_link,

      //registration settings
      enable_landing_page: setting?.enable_landing_page,
      free_registration: free_registration,
      activation_email: setting?.activation_email,
      premium_upgrade: setting?.premium_upgrade,
      access_free: setting?.access_free,

      //search settings
      search_title_status: search_title_status,
      search_category_status: search_category_status,
      search_tags_status: search_tags_status,
      search_description_status: search_description_status,
      search_details_status: search_details_status,

      //serires settings
      series_season: setting?.series_season,
      series_networks_status: series_networks_status,

      //site settings
      website_name: setting?.website_name,
      website_description: setting?.website_description,
      // logo: setting?.logo,
      logo_height: setting?.logo_height,
      logo_width: setting?.logo_width,
      // favicon: setting?.favicon,

      //social network settings
      facebook_page_id: setting?.facebook_page_id,
      google_page_id: setting?.google_page_id,
      twitter_page_id: setting?.twitter_page_id,
      instagram_page_id: setting?.instagram_page_id,
      linkedin_page_id: setting?.linkedin_page_id,
      whatsapp_page_id: setting?.whatsapp_page_id,
      skype_page_id: setting?.skype_page_id,
      youtube_page_id: setting?.youtube_page_id,
      tiktok_page_id: setting?.tiktok_page_id,
      email_page_id: setting?.email_page_id,

      //default_time_zone
      default_time_zone: setting?.default_time_zone,

      // video settings 
      videos_per_page: videos_per_page,
      posts_per_page: setting?.posts_per_page,
      show_description: show_description,
      show_Links_and_details: show_Links_and_details,
      show_genre: show_genre,
      show_languages: show_languages,
      show_subtitle: show_subtitle,
      show_artist: show_artist,
      show_recommended_videos: show_recommended_videos,
      show_views: show_views,
      videos_expiry_status: videos_expiry_status,
      epg_status: epg_status,

      epg_status: enable_ppv_rent,

      earn_amount: setting?.earn_amount ? parseInt(setting?.earn_amount, 10) : 0,
      video_clip_enable: setting?.video_clip_enable ? parseInt(setting?.video_clip_enable, 10) : 0,
      enable_skeleton_loader: setting?.enable_skeleton_loader ? parseInt(setting?.enable_skeleton_loader, 10) : 0,
      google_font_url: setting?.google_font_url || null,
      google_font_name: setting?.google_font_name || null,

    };

    let firstApiStatus = false;
    let secondApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/setting/store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res?.json();

      if (resjson?.status === true) {
        firstApiStatus = true;

        resultapi = resjson;

        // Use Global Image Uploads API for only the changed image fields
        const formData = new FormData();
        const imageFields = [];
        const modelName = "Setting";
        const settingId = setting?.id;
        formData.append("id", settingId);
        formData.append("modelName", modelName);

        if (selectedFile1) {
          formData.append("favicon", selectedFile1);
          imageFields.push("favicon");
        }

        if (selectedFile2) {
          formData.append("logo", selectedFile2);
          imageFields.push("logo");
        }

        if (imageFields.length > 0) {
          imageFields.forEach((field) => {
            formData.append('imageFields[]', field);
          });
          const imageResponse = await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: formData,
          });
          if (imageResponse?.status === true) {
            secondApiStatus = true;
          }
        } else {
          secondApiStatus = true;
        }

        // Upload font file separately via AdminSetting model
        if (selectedFontFile) {
          const fontFormData = new FormData();
          fontFormData.append("id", setting?.admin_setting_id || 1);
          fontFormData.append("modelName", "AdminSetting");
          fontFormData.append("font_file", selectedFontFile);
          fontFormData.append("fontFields[]", "font_file");
          await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: fontFormData,
          });
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred during update");
    }

    if (firstApiStatus && secondApiStatus) {
      setValidationMessagewebsite_name("");
      setValidationMessagelogo_width("");
      setValidationMessagelogo_height("");
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      toast.success("Site Setting Updated Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      setProcessing(false);
      setShowOverlay(false);

    } else {
      if (resjson?.status === false) {
        var resultError = resjson;
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setIsValidationHiddenwebsite_name(false);
        setIsValidationHiddenlogo_height(false);
        setIsValidationHiddenlogo_width(false);
        toast.error(resjson?.message || "Failed to update site settings");
      } else {
        toast.error("Failed to update site settings");
      }
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      <div className=" mt-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              {/* <Link to="/settings" className="backarrow">
                <img src={backarrow} alt="flogo" width={20} height={20} />{" "}
                <span> Back</span>
              </Link> */}
              <div className="col-6 col-sm-6 col-lg-6">
                <h4 className="admin-title mb-0 theme-text-color text-md-start">Site Settings</h4>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    <span>Update</span>
                  </button>
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
            </div>

            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Create Site</h5>
                  <div className=" text-start">
                    <p className="mandatorySimple theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Website Name</p>
                    <div className="mt-2">
                      <input
                        type="text"
                        id="website_name"
                        name="website_name"
                        className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                        onChange={handleInput}
                        value={setting?.website_name}
                        ref={website_nameInputRef}
                        maxLength={30}
                      />
                    </div>
                    <span className="errorred">
                      {!isValidationHiddenwebsite_name && (
                        <p>{validationMessagewebsite_name}</p>
                      )}
                    </span>
                  </div>

                  <div className="text-start mt-3">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <p className="theme-text-color m-0 admin-input-title">Enable Skeleton Loader</p>
                        <small className="theme-text-color opacity-75 admin-input-description">Show skeleton loaders when navigating between pages (Turn off for fastest perceived loading)</small>
                      </div>
                      <AdminSwitch
                        id="enable_skeleton_loader"
                        name="enable_skeleton_loader"
                        onChange={handleInputenable}
                        checked={setting?.enable_skeleton_loader == 1}
                      />
                    </div>
                  </div>

                  <div className="text-start mt-3">
                    <p className="theme-text-color mb-1 mt-0 admin-input-title d-block position-relative">Google Fonts URL</p>
                    <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
                      Paste the Google Fonts CSS link URL. You can include multiple font families in one URL.
                    </small>
                    <div className="mt-2">
                      <input
                        type="url"
                        id="google_font_url"
                        name="google_font_url"
                        className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                        onChange={handleInput}
                        value={setting?.google_font_url || ""}
                        placeholder="https://fonts.googleapis.com/css2?family=..."
                      />
                    </div>
                    <p className="theme-text-color mb-1 mt-0 admin-input-title d-block position-relative">Font Family Name</p>
                    <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
                      Type the exact font name you want to apply from the URL above.<br />
                      Example: if your URL has <span className="opacity-75">Space+Mono</span> → type <span className="opacity-75">Space Mono</span>
                    </small>
                    <div className="mt-2">
                      <input
                        type="text"
                        id="google_font_name"
                        name="google_font_name"
                        className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                        onChange={handleInput}
                        value={setting?.google_font_name || ""}
                        placeholder="e.g. Space Mono"
                      />
                    </div>

                    <p className="theme-text-color mb-1 mt-0 admin-input-title d-block position-relative">Custom Font File (TTF)</p>
                    <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
                      Upload a .ttf font file for mobile apps to use. The file URL will be displayed below after saving.
                    </small>
                    <div className="mt-2">
                      {selectedFontFile ? (
                        <div className="d-flex align-items-center gap-2 p-2 custom-input-border rounded-3 mb-2">
                          <span className="theme-text-color admin-input-description flex-grow-1 text-truncate">{selectedFontFile.name}</span>
                          <button type="button" onClick={handleClearFontFile} className="btn btn-sm btn-outline-danger py-0 px-2">✕</button>
                        </div>
                      ) : (
                        <label className="d-block w-100 custom-input-border rounded-3 p-3 text-center mb-2" style={{ cursor: "pointer", borderStyle: "dashed" }}>
                          <input type="file" accept=".ttf" onChange={handleFontFileChange} className="d-none" />
                          <span className="theme-text-color opacity-75 admin-input-description">Click to select a .ttf file</span>
                        </label>
                      )}
                      {setting?.font_file && !selectedFontFile && (
                        <div className="mt-2 p-2 custom-input-border rounded-3">
                          <p className="theme-text-color opacity-75 admin-input-description mb-1">Current font file URL (for mobile access):</p>
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="text"
                              readOnly
                              value={setting?.font_file}
                              className="rs-input form-control-sm custom-input custom-input-border w-100 bg-transparent theme-text-color"
                              onClick={(e) => e.target.select()}
                            />
                            <button
                              type="button"
                              className="btn btn-sm button-bg-color theme-button-text-color px-2 py-1 flex-shrink-0"
                              onClick={() => { navigator.clipboard.writeText(setting?.font_file); toast.success("URL copied!"); }}
                            >Copy</button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="text-start">
                    <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Website Description</p>
                    <div className="mt-2">
                      <textarea
                        type="text"
                        id="website_description"
                        name="website_description"
                        value={setting?.website_description}
                        className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                        onChange={handleInput}
                        placeholder=""
                      ></textarea>
                    </div>
                  </div>

                  <div className="row text-start">
                    <div className="col-lg-12">
                      <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Logo
                        <span className="ms-1 mb-3 mt-0 theme-text-color opacity-75 admin-input-description">(Dimensions: 180px X 29px)</span>
                      </p>

                      <div className="mt-2">
                        <div className="mt-2">
                          <p className="mandatorySimple mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Enter Your Logo Width</p>
                          <div className="mt-2">
                            <input
                              type="number"
                              id="logo_width"
                              name="logo_width"
                              value={setting?.logo_width}
                              ref={logo_widthInputRef}
                              className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                              onChange={handleInput}
                              placeholder=""
                              min="0"
                            />



                          </div>
                          <span className="errorred">
                            {!isValidationHiddenlogo_width && (
                              <p>{validationMessagelogo_width}</p>
                            )}
                          </span>
                        </div>

                        <div className="mt-2">
                          <p className="mandatorySimple mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Enter Your Logo Height</p>
                          <div className="mt-2">
                            <input
                              type="number"
                              id="logo_height"
                              name="logo_height"
                              value={setting?.logo_height}
                              ref={logo_heightInputRef}
                              className="rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
                              onChange={handleInput}
                              placeholder=""
                              min="0"
                            />
                          </div>
                          <span className="errorred">
                            {!isValidationHiddenlogo_height && (
                              <p>{validationMessagelogo_height}</p>
                            )}
                          </span>
                        </div>

                        {/* <div className="row">
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                            <small className="m-0">Enter Your Logo Height</small>
                            <div className="mt-2">
                              <input
                                type="text"
                                id="logo_width"
                                name="logo_width"
                                value={setting?.logo_width}
                                className="rs-input form-control-lg"
                                onChange={handleInput}
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                            <small className="m-0">
                              Enter Your Logo Height
                            </small>
                            <div className="mt-2">
                              <input
                                type="text"
                                id="logo_height"
                                name="logo_height"
                                value={setting?.logo_height}
                                className="rs-input form-control-lg"
                                onChange={handleInput}
                                placeholder=""
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-start mb-3">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    <span>Update</span>
                  </button>
                </div>
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Thumbnails</h5>
                  <div className=" text-start">
                    <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Site Favicon</p>
                    <AdminImageUploadZone
                      onChange={handleFileChange}
                      selectedFile={selectedFile1}
                      uploadedImage={favicon}
                      onDelete={handleClearSelectFile}
                      name="favicon"
                      id={setting?.id}
                      idAttribute="site-setting-favicon"
                    />
                  </div>

                  <div className=" text-start">
                    <p className="theme-text-color mb-3 mt-2 admin-input-title d-block position-relative">Site logo</p>
                    <AdminImageUploadZone
                      onChange={handleFileChange}
                      selectedFile={selectedFile2}
                      uploadedImage={logo}
                      onDelete={handleClearSelectFile}
                      name="logo"
                      id={setting?.id}
                      idAttribute="site-setting-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Site_Setting;
